module.exports = __webpack_public_path__ + "img/backyard-alt-angle.82f8db6d.webp";